export default __webpack_public_path__ + "static/media/western.f1ff2056.png";